import { InteractionType } from "@/common/types";
import { MessagingInteractionContentProps } from "./types";
import { WhatsAppChatInteractionContent } from "./WhatsAppChatInteractionContent";
import { WebchatChatInteractionContent } from "./WebchatChatInteractionContent";
import { TranscriptionChatInteractionContent } from "./TranscriptionChatInteractionContent";

export const MessagingChatInteractionContent = (
	props: MessagingInteractionContentProps
) => {
	switch (props.type) {
		case InteractionType.WhatsApp:
			return <WhatsAppChatInteractionContent {...props} />;
		case InteractionType.Webchat:
			return <WebchatChatInteractionContent {...props} />;
		case InteractionType.Call:
			return <TranscriptionChatInteractionContent {...props} />;
		default:
			throw new Error("Unsupported channel");
	}
};
